import { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
//import QuillBetterTable from "quill-table-better";
import { stdObject } from "../data/types/stdObject";

// Quill.register(
//   {
//     "modules/better-table": QuillBetterTable,
//   },
//   true,
// );

export default function TextEditor({ data }: stdObject) {
  const editorRef = useRef<HTMLDivElement>(null);
  const quillRef = useRef<Quill | null>(null);

  useEffect(() => {
    if (!quillRef.current && editorRef.current) {
      const quill = new Quill(editorRef.current, {
        theme: "snow",
        // placeholder: "Escribe algo...",
        modules: {
          // table: false,
          toolbar: [
            [{ font: [] }],
            // [{ header: [1, 2, false] }],
            [{ size: [] }],
            [{ color: [] }, { background: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["image", "video"],
            ["link"],
            // ["table"],
            ["clean"],
          ],
          // "better-table": {
          //   operationMenu: {
          //     items: {
          //       unmergeCells: {
          //         text: "Another unmerge cells name",
          //       },
          //     },
          //   },
          // },
          // keyboard: {
          //   bindings: QuillBetterTable.keyboardBindings,
          // },
        },
      });

      if (typeof data.value === "string" && data.value !== "") {
        quill.root.innerHTML = data.value;
      }

      quillRef.current = quill;
      const handleTextChange = () => {
        const delta = quillRef.current?.root.innerHTML; //quill.getContents(); //
        if (typeof delta === "string") {
          data.onChange(delta);
        }
      };

      quillRef.current.on("text-change", handleTextChange);

      return () => {
        quill.off("text-change", handleTextChange);
        // quillRef.current = null;
      };
    }
  }, []);

  const handleInsertTable = () => {
    const tableModule = quillRef.current?.getModule("better-table") as any;
    tableModule?.insertTable(3, 3);
  };

  return (
    <div className="textEditor">
      {/*<button onClick={handleInsertTable}>Insertar Tabla 3x3</button>*/}
      <div ref={editorRef} />
    </div>
  );
}
